"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const callout_1 = __importStar(require("../callout"));
const styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
const NavigateByCityLetter = ({ locationsByCityLetter }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const listItems = (0, react_1.useMemo)(() => {
        let listItems = [];
        for (var i = 65; i <= 90; i++) {
            const character = String.fromCharCode(i);
            if (Object.keys(locationsByCityLetter).includes(character)) {
                listItems.push((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ href: `#${character}-${t("locations")}` }, { children: character })) }, character));
            }
            else {
                listItems.push((0, jsx_runtime_1.jsx)("li", { children: character }, character));
            }
        }
        return listItems;
    }, [locationsByCityLetter]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `ontario-grid-spacing-escape lt-medium ontario-padding-top-5` }, { children: (0, jsx_runtime_1.jsx)(callout_1.default, { className: `${styles_module_scss_1.default.navigateByCityLetter}`, data: {
                type: callout_1.CalloutType.Informational,
                message: (0, jsx_runtime_1.jsx)("ul", Object.assign({ className: "ontario-margin-top-0" }, { children: listItems })),
            } }) })));
};
exports.default = NavigateByCityLetter;
